import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { Html } from 'src/app/shared/components/html';

import {
	changeDotOrgCaptionStyles,
	petitionTitleStyles,
	postTitleContainerStyles,
	profileContainerStyles,
} from './PostPreview.styles';
import { htmlContainerStyles, mainContainerStyles } from './YourPost.styles';

type YourPostProps = {
	isExpanded: boolean;
	postText?: string;
	imageUrl?: string | null;
	previewTitle?: string;
};

/*
	This component is a visual representation of a Facebook post preview. For that, it
	doesn't use many of the design system components, as they don't fit the design requirements.
	It doesn't use any legacy design system components either.
 */
export function YourPost({ isExpanded, postText, imageUrl, previewTitle }: YourPostProps) {
	const { resolveUrl } = useUtilityContext();

	return (
		<section
			data-testid="preview-post-layout"
			role="group"
			aria-label={`${isExpanded ? 'Expanded ' : ''}Preview Post`}
			className={mainContainerStyles({ isExpanded })}
		>
			<div className="flex flex-col gap-3">
				<div className="px-1.5">
					{/* Not using the Image component as this image doesn't have a supported aspect ratio */}
					<img
						src="https://static.change.org/images/pre-made-post-modal-mock-post-title.png"
						alt="Post title"
						className={profileContainerStyles({ isExpanded })}
					/>
					<Html as="pre" html={postText || ''} className={htmlContainerStyles({ isExpanded })} />
				</div>
				<div>
					{/* Not using the Image component as this image doesn't have a supported aspect ratio */}
					<img src={imageUrl ? resolveUrl(imageUrl) : ''} alt="Preview Link" className="w-[100%]" />
					<div className={postTitleContainerStyles({ isExpanded })}>
						<span className={changeDotOrgCaptionStyles({ isExpanded })}>change.org</span>
						<span className={petitionTitleStyles({ isExpanded })}>{previewTitle}</span>
					</div>
				</div>
			</div>
			{/* The following images are only visible when the component is *expanded* in the browser */}
			<img
				src="https://static.change.org/images/pre-made-post-modal-mock-post.png?V2"
				alt="Post background"
				className="h-full w-full object-cover"
			/>
			<img
				src="https://static.change.org/images/pre-made-post-modal-mock-post.png?V2"
				alt="Post background"
				className="h-full w-full object-cover"
			/>
		</section>
	);
}
